export default function Loading() {
  return <p><i>Chargement...</i></p>;
}
